import { signal } from "@preact/signals-react"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"

export const alertsSection = signal(ALERTS.PRICE_COMPARISON)
export const isMinMaxPriceTabLoading = signal(false)
export const isPriceChangeTabLoading = signal(false)
export const isPriceComparisonTabLoading = signal(false)
export const isNoAvailabilityTabLoading = signal(false)
export const isRatingTabLoading = signal(false)

export const isPriceComparisonTabEmpty = signal(false)
export const isNoAvailabilityTabEmpty = signal(false)
export const isPriceChangeTabEmpty = signal(false)
export const isMinMaxPriceTabEmpty = signal(false)
export const isRatingTabEmpty = signal(false)